<template>
  <div class="md-layout md-alignment-bottom-left note-list-item">
    <div class="md-layout-item md-size-100">
      <span class="text-editor-content" v-html="note.content"></span>
    </div>
    <div class="md-layout-item md-size-80">
      <h6 slot="footer" class="text-muted">
        <small>
          <i class="fas fa-clock"></i>
          {{ note.created_at | fromNow }}
        </small>
      </h6>
    </div>
    <div class="md-layout-item md-size-20 text-right">
      <md-button
        class="md-just-icon md-simple md-danger"
        @click="deleteNote(note)"
      >
        <md-icon>delete</md-icon>
        <md-tooltip md-direction="top">Delete Note</md-tooltip>
      </md-button>
      <md-button
        class="md-just-icon md-simple md-success"
        @click="editNote(note)"
      >
        <md-icon>edit</md-icon>
        <md-tooltip md-direction="top">Edit Note</md-tooltip>
      </md-button>
    </div>
  </div>
</template>

<script>
export default {
  name: "NotesItem",

  props: {
    note: Object
  },

  methods: {
    editNote(note) {
      this.$emit("editNote", note);
    },
    deleteNote(note) {
      this.$emit("deleteNote", note);
    }
  }
};
</script>

<style lang="scss" scoped>
.note-list-item {
  margin-bottom: 1rem;
  border-bottom: 1px solid #00bcd4;

  h6 {
    margin-bottom: 5px;
    margin-top: 0;
  }

  .md-button {
    margin: 0;
    padding: 5px;
    height: 27px;
    min-width: 27px;
    width: 27px;
    line-height: 27px;
  }
}
</style>
